export enum IInboxAuthorType {
  CONTACT = "contact",
  AGENT = "agent",
  AUTOMATED = "automated",
}
